import { defineMessages } from 'react-intl-next';

export default defineMessages({
    couldntLoadRequestTitle: {
        defaultMessage: 'We couldn’t load this request',
        description: 'Title shown in section message when form could not be loaded',
        id: 'sd.jsm.customerview.portalrequesttype.couldnt.load.request.title',
    },
    couldntLoadRequestGenericDescription: {
        defaultMessage: 'Select a different request, or contact your admin.',
        description: 'Description shown in section message when form could not be loaded due to an unknown reason.',
        id: 'sd.jsm.customerview.portalrequesttype.couldnt.load.request.generic.description',
    },
    couldntLoadRequestAnonymousDescription: {
        defaultMessage: 'Log in with a valid account to access, or select a different request.',
        description:
            'Description shown in section message when form could not be loaded due to user not being logged in.',
        id: 'sd.jsm.customerview.portalrequesttype.couldnt.load.request.anonymous.description',
    },
    couldntLoadRequestUnlicensedDescription: {
        defaultMessage:
            'This request is only available to users with Jira access. Select a different request, or contact your admin.',
        description:
            'Description shown in section message when form could not be loaded due to not having Jira access.',
        id: 'sd.jsm.customerview.portalrequesttype.couldnt.load.request.unlicensed.description',
    },
    couldntLoadRequestConditionalSectionDescription: {
        defaultMessage:
            'Remove required fields from conditional sections, or change their linked Jira fields to optional.',
        description:
            'Description shown in section message when form could not be loaded due to required Jira fields being inside conditional section.',
        id: 'sd.jsm.customerview.portalrequesttype.couldnt.load.request.conditional.section.description',
    },
});
